import { PickListItem, JsonItem, AppUserGroupCommittee, AppUserExtended, TeamsAccessResponseAll } from "../list-management.objects";
import _ from "lodash";

declare var $: any;

export class TeamsAccessModal {
    modalId: string;
    teamsListContainer: JQuery<HTMLElement>;
    loadingContainer: JQuery<HTMLElement>;

    teamsAccessDropdownContainer: JQuery<HTMLElement>;
    teamsAccessDropdown: JQuery<HTMLElement>;
    teamsCheckDescription: JQuery<HTMLElement>;

    noCheckAccessBtnText: JQuery<HTMLElement>;
    checkAccessBtnContainer: JQuery<HTMLElement>;
    checkAccessBtn: JQuery<HTMLElement>;

    refreshTeamsCheckBtnContainer: JQuery<HTMLElement>;
    refreshTeamsCheckBtn: JQuery<HTMLElement>;

    currentUsers: AppUserExtended[];

    currentAcceptInviteList: TeamsAccessResponseAll;
    currentPrivateChannelMemberList: TeamsAccessResponseAll[];
    currentRemovedMemberList: TeamsAccessResponseAll[];

    constructor(modalId: string) {
        this.modalId = modalId;

        this.teamsListContainer = $(`#${modalId}`).find(".teams-list-container");
        this.loadingContainer = $(`#${modalId}`).find(".loading-container");

        this.teamsAccessDropdownContainer = $(`#${modalId}`).find("#teams-access-dropdown-container");
        this.teamsCheckDescription = $(`#${modalId}`).find("#teams-check-description");

        this.checkAccessBtnContainer = $(`#${modalId}`).find("#check-access-btn-container");
        this.checkAccessBtn = $(`#${modalId}`).find("#check-teams-btn");
        this.noCheckAccessBtnText = $(`#${modalId}`).find("#no-check-teams-btn-text");

        this.refreshTeamsCheckBtnContainer = $(`#${modalId}`).find("#teams-list-container-refresh-btn-container");
        this.refreshTeamsCheckBtn = $(`#${modalId}`).find(".refresh-teams-btn");

        this.checkAccessBtn.on("click", async () => {
            await this.checkTeamsAccess();
        });

        this.refreshTeamsCheckBtn.on("click", async () => {
            await this.refreshTeamsCheck();
        });
    }

    async openModal(appUsers: any): Promise<any> {
        this.currentUsers = <AppUserExtended[]>appUsers;

        this.initializeModal();

        // Open Modal
        $(`#${this.modalId}`).modal("show");
    }

    initializeModal(): void {
        this.teamsAccessDropdownContainer.removeClass("d-none");
        this.checkAccessBtnContainer.removeClass("d-none");
        this.loadingContainer.addClass("d-none");
        this.teamsListContainer.addClass("d-none");

        this.createTeamsCheckDropdown();

        this.updateDescription();
    }

    async refreshTeamsCheck() {
        let checkVal = this.teamsAccessDropdown.val();

        if (!checkVal) {
            return;
        }

        if (checkVal == "accepted-invite") {
            await this.refreshTeamsInviteAccess();
        }
        else if (checkVal == "in-channel") {
            await this.refreshTeamsChannelAccess();
        }
        else if (checkVal == "removed") {
            await this.refreshRemovedTeamsAccess();
        }
    }

    createTeamsCheckDropdown(): void {
        let dropdownContent = `
            <div id="teams-access-selction" class="col-12 col-md-6 col-lg-5 col-xl-3 px-0">
                <label class="font-weight-500 d-block font-size16">Teams Access Check</label>
                <select id="teams-access-selection-dropdown" class="selectpicker dropdown" title="None Selected" data-width="100%" data-container="body" data-dropup-auto="false" data-size="5"></select>
            </div>
        `;

        this.teamsAccessDropdownContainer.empty().html(dropdownContent);

        this.teamsAccessDropdown = $(`#${this.modalId}`).find("#teams-access-selection-dropdown");

        let options: string[][] = [
            ["accepted-invite", "Accepted Teams Invitation"],
            ["in-channel", "Added to Group Private Channel"],
            ["removed", "Properly Removed from Team/Channels"]
        ];

        options.forEach(element => {
            this.teamsAccessDropdown.append(new Option(element[1], element[0], false, false))
        })

        this.teamsAccessDropdown.selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        this.teamsAccessDropdown.selectpicker("refresh");

        this.teamsAccessDropdown.on("changed.bs.select", () => {
            this.updateDescription();
        })
    }

    updateDescription(): void {
        let description = "";
        let checkVal = this.teamsAccessDropdown.val();

        if (checkVal == "accepted-invite") {
            description = "Use the 'Check Teams Access' button to see if active ReVAMPP Users in groups have accepted their Teams Invitation to the collaborative team. Users not in this list have either not been sent an invitation, or have not yet accepted it.";
        }
        else if (checkVal == "in-channel") {
            description = "Use the 'Check Teams Access' button to see if active ReVAMPP Users in groups have been added to the correct private channel for their group."
        }
        else if (checkVal == "removed") {
            description = "Use the 'Check Teams Access' button to see if ReVAMPP Users who have been deactivated or removed from a group have been properly removed from the collaborative Team and private channel."
        }

        this.teamsListContainer.addClass('d-none');

        if (description) {
            this.noCheckAccessBtnText.addClass("d-none");
            this.checkAccessBtn.removeClass("d-none");
        }
        else {
            this.noCheckAccessBtnText.removeClass("d-none");
            this.checkAccessBtn.addClass("d-none");
        }

        this.refreshTeamsCheckBtnContainer.addClass("d-none");
        this.checkAccessBtnContainer.removeClass("d-none");

        this.teamsCheckDescription.text(description);
    }

    async checkTeamsAccess() {
        let checkVal = this.teamsAccessDropdown.val();

        if (!checkVal) {
            return;
        }

        this.checkAccessBtnContainer.addClass('d-none');
        this.toggleLoading(true);

        if (checkVal == "accepted-invite") {           
            let response: TeamsAccessResponseAll = await this.getTeamsAcceptedInvite(); 
            this.updateTeamsAcceptedInviteDisplay(response);    
            this.currentAcceptInviteList = response;
        }
        else if (checkVal == "in-channel") {
            let response: TeamsAccessResponseAll[] = await this.getTeamsChannelAccess();
            this.updateTeamsChannelAccessDisplay(response);
            this.currentPrivateChannelMemberList = response;
        }
        else if (checkVal == "removed") {
            let response: TeamsAccessResponseAll[] = await this.getTeamsRemovedAccess();
            this.updateTeamsRemovedAccessDisplay(response);
            this.currentRemovedMemberList = response;
        }

        this.toggleLoading(false);

        // Get Popovers working
        $('[data-toggle="popover"]').popover();
    }

    async refreshTeamsInviteAccess(): Promise<any> {
        this.toggleLoading(true);
        let teamsInviteList: TeamsAccessResponseAll = await this.getTeamsAcceptedInvite(true);
        this.updateTeamsAcceptedInviteDisplay(teamsInviteList);
        this.toggleLoading(false);
        this.currentAcceptInviteList = teamsInviteList;

        // Get Popovers working
        $('[data-toggle="popover"]').popover();
    }

    async refreshTeamsChannelAccess(): Promise<any> {
        this.toggleLoading(true);
        let teamsAccessChannelList: TeamsAccessResponseAll[] = await this.getTeamsChannelAccess(true);
        this.updateTeamsChannelAccessDisplay(teamsAccessChannelList);
        this.toggleLoading(false);
        this.currentPrivateChannelMemberList = teamsAccessChannelList;
    }

    async refreshRemovedTeamsAccess(): Promise<any> {
        this.toggleLoading(true);
        let removedTeamsAccessList: TeamsAccessResponseAll[] = await this.getTeamsRemovedAccess(true);
        this.updateTeamsRemovedAccessDisplay(removedTeamsAccessList);
        this.toggleLoading(false);
        this.currentRemovedMemberList = removedTeamsAccessList;
    }

    toggleLoading(isLoading: boolean) {
        if (isLoading) {
            this.teamsAccessDropdownContainer.addClass("d-none");
            this.loadingContainer.removeClass("d-none");
            this.teamsListContainer.addClass("d-none");
            this.refreshTeamsCheckBtnContainer.addClass("d-none");
        }
        else {
            this.teamsAccessDropdownContainer.removeClass("d-none");
            this.loadingContainer.addClass("d-none");
            this.teamsListContainer.removeClass("d-none");
            this.refreshTeamsCheckBtnContainer.removeClass("d-none");
        }
    }

    updateTeamsAcceptedInviteDisplay(acceptedInviteList: TeamsAccessResponseAll): void  {
        let content = "";

        let isMissingMembers: boolean = false;
        if (acceptedInviteList.MissingMembers.length > 0) {
            isMissingMembers = true;
        }

        let title = `
            <div class="mb-2">
                <span class="font-size18 font-weight-600">${acceptedInviteList.TeamDisplayName}</span>
            </div>  
        `

        let missingMemberTableInner = ``
        acceptedInviteList.MissingMembers.forEach(email => {
            missingMemberTableInner += `<div class="teams-access-table-row">${email}</div>`
        });

        let copyMissingBtn = `
            <div>
                <a class="revampp-white-btn copy-not-accepted-btn" role="button" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="Copied!" data-placement="top">Copy <i class="fas fa-copy pl-2"></i></a>
            </div>
        `
        if (acceptedInviteList.MissingMembers.length == 0) {
            missingMemberTableInner += `<div class="teams-access-table-row text-center">All members have accepted the teams invitation.</div>`
            copyMissingBtn = "";
        }
        let missingMemberTable = `
            <div class="teams-access-table">
                <div class="teams-access-table-row teams-access-table-head">Email</div>
                <div class="teams-access-table-body">
                    ${missingMemberTableInner}
                </div>
            </div>
        `;

        let addedMemberTableInner = ``
        acceptedInviteList.CurrentMembers.forEach(email => {
            addedMemberTableInner += `<div class="teams-access-table-row">${email}</div>`
        });

        let copyAddedBtn = `
            <div>
                <a class="revampp-white-btn copy-accepted-btn" role="button" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="Copied!" data-placement="top">Copy <i class="fas fa-copy pl-2"></i></a>
            </div>
        `;

        if (acceptedInviteList.CurrentMembers.length == 0) {
            addedMemberTableInner += `<div class="teams-access-table-row text-center">No found members have accepted teams invitation.</div>`
            copyAddedBtn = "";
        }
        let addedMemberTable = `
            <div class="teams-access-table">
                <div class="teams-access-table-row teams-access-table-head">Email</div>
                <div class="teams-access-table-body">
                    ${addedMemberTableInner}
                </div>
            </div>
        `;

        content = `
            <p class="mb-3">The tables below show if ReVAMPP users have accepted their Teams invite to the collaborative channel. Users in the "Has Accepted Invite" table are those who have accepted the invitation, but have not yet been added to any of the team's private channels. Users in the "Not Sent or Accepted Invite" table are those who have either not been sent an invitation or have not yet accepted it.</p>
            ${title}
            <div class="row">
                <div class="col-md-6 col-12 mb-3">
                    <div class="mb-1 d-flex justify-content-between align-items-baseline">
                        <div>
                            <span class="pr-1"><i class="fa-solid fa-circle-xmark fa-lg error-icon"></i></span>
                            <span class="teams-access-table-title">Not Sent or Accepted Invite</span>
                        </div>                      
                        ${copyMissingBtn}
                    </div>
                    ${missingMemberTable}
                </div>
                <div class="col-md-6 col-12 mb-3">
                    <div class="mb-1 d-flex justify-content-between align-items-baseline">
                        <div>
                            <span class="pr-1"><i class="fa-solid fa-circle-check fa-lg success-icon"></i></span>
                            <span class="teams-access-table-title">Accepted Invite, Not in Private Channel</span>
                        </div>                      
                        ${copyAddedBtn}
                    </div>
                    ${addedMemberTable}
                </div>
            </div>
        `

        this.teamsListContainer.empty().html(content);

        $(".copy-not-accepted-btn").on("click", async () => {
            let missingMembers = this.currentAcceptInviteList.MissingMembers;
            let copyText = missingMembers.join("\n");
            try {
                await navigator.clipboard.writeText(copyText);
            }
            catch (e) {
                console.log(e);
            }
        });

        $(".copy-accepted-btn").on("click", async () => {
            let acceptedMembers = this.currentAcceptInviteList.CurrentMembers;
            let copyText = acceptedMembers.join("\n");
            try {
                await navigator.clipboard.writeText(copyText);
            }
            catch (e) {
                console.log(e);
            }
        });
    }

    updateTeamsChannelAccessDisplay(teamsChannelAccessList: TeamsAccessResponseAll[]) {
        let content = "";
        for (let i = 0; i < teamsChannelAccessList.length; i++) {
            let currentTeam = teamsChannelAccessList[i];

            let isMissingMembers: boolean = false;
            if (currentTeam.MissingMembers.length > 0) {
                isMissingMembers = true;
            }

            let accessIcon = `<i class="fa-solid fa-circle-check fa-lg success-icon"></i>`;
            if (isMissingMembers) {
                accessIcon = `<i class="fa-solid fa-circle-xmark fa-lg error-icon"></i>`;
            }

            let title = `
                <div class='d-flex justify-content-between'>
                    <div>
                        <span class="pr-1">${accessIcon}</span>
                        <span class="teams-access-collapse-title">${currentTeam.TeamDisplayName}</span>
                    </div>
                    <div class="collapse-indicator">
                        
                    </div>
                </div>     
            `

            let missingMemberTableInner = ``
            currentTeam.MissingMembers.forEach(email => {
                missingMemberTableInner += `<div class="teams-access-table-row">${email}</div>`
            });

            let copyMissingBtn = `
                <div>
                    <a class="revampp-white-btn copy-missing-access-btn" role="button" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="Copied!" data-placement="top" data-item-index="${i}">Copy <i class="fas fa-copy pl-2"></i></a>
                </div>
            `;

            if (currentTeam.MissingMembers.length == 0) {
                missingMemberTableInner += `<div class="teams-access-table-row text-center">All members have access.</div>`
                copyMissingBtn = "";
            }
            let missingMemberTable = `
                <div class="teams-access-table">
                    <div class="teams-access-table-row teams-access-table-head">Email</div>
                    <div class="teams-access-table-body">
                        ${missingMemberTableInner}
                    </div>
                </div>
            `

            let addedMemberTableInner = ``
            currentTeam.CurrentMembers.forEach(email => {
                addedMemberTableInner += `<div class="teams-access-table-row">${email}</div>`
            });

            let copyAddedBtn = `
                <div>
                    <a class="revampp-white-btn copy-has-access-btn" role="button" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="Copied!" data-placement="top">Copy <i class="fas fa-copy pl-2"></i></a>
                </div>
            `;
            if (currentTeam.CurrentMembers.length == 0) {
                addedMemberTableInner += `<div class="teams-access-table-row text-center">No members have access.</div>`
                copyAddedBtn = "";
            }
            let addedMemberTable = `
                <div class="teams-access-table">
                    <div class="teams-access-table-row teams-access-table-head">Email</div>
                    <div class="teams-access-table-body">
                        ${addedMemberTableInner}
                    </div>
                </div>
            `

            let goToTeamBtn = `
                <div class="mb-3">
                    <a href="${currentTeam.TeamsLink}" target="_blank" class="text-decoration-none revampp-white-btn">Go to Team</a>
                </div>
            `;

            let expandContent = `
                <div id="teams-access-list-collapse-${i}" class="teams-access-collapse-content collapse" data-parent="#teams-access-card-parent">                  
                    <div class="row p-3">
                        <div class="col-md-6 col-12 mb-3">
                            <div class="mb-1 d-flex justify-content-between align-items-baseline">
                                <div>
                                    <span class="pr-1"><i class="fa-solid fa-circle-xmark fa-lg error-icon"></i></span>
                                    <span class="teams-access-table-title">Missing Teams Access</span>
                                </div>
                                ${copyMissingBtn}
                            </div>
                            ${missingMemberTable}
                        </div>
                        <div class="col-md-6 col-12 mb-3">
                            <div class="mb-1 d-flex justify-content-between align-items-baseline">
                                <div>
                                    <span class="pr-1"><i class="fa-solid fa-circle-check fa-lg success-icon"></i></span>
                                    <span class="teams-access-table-title">Has Teams Access</span>
                                </div>
                                ${copyAddedBtn}
                            </div>
                            ${addedMemberTable}
                        </div>
                    </div>
                </div>
            `

            let teamCard = `
                <div class="teams-access-list-item">
                    <div class="teams-access-item-block collapsed" data-toggle="collapse" data-target="#teams-access-list-collapse-${i}">
                        <div class="teams-access-block-title">
                            ${title}
                        </div>
                    </div>
                    ${expandContent}
                </div>
            `
            content += teamCard;
        }

        let newDisplay = `
            <p class="mb-3">The tables below show if ReVAMPP users have been added to their group's private channel in the collaborative team. Users in the "Missing Teams Access" table are those who have not been added to their group's channel. Users in the "Has Teams Access" table are those who have been correctly added to their group's channel.</p>
            <div id="teams-access-card-parent">
                ${content}
            </div>
        `;


        this.teamsListContainer.empty().html(newDisplay);

        $(".copy-missing-access-btn").on("click", async (e: Event) => {
            let index = $(e.currentTarget).data("item-index");
            if (index != undefined) {
                let i = parseInt(index);
                let missingMembers = this.currentPrivateChannelMemberList[i]?.MissingMembers;
                if (missingMembers) {
                    let copyText = missingMembers.join("\n");

                    try {
                        await navigator.clipboard.writeText(copyText);
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
            }
        });

        $(".copy-has-access-btn").on("click", async (e: Event) => {
            let index = $(e.currentTarget).data("item-index");
            if (index != undefined) {
                let i = parseInt(index);
                let currentMembers = this.currentPrivateChannelMemberList[i]?.CurrentMembers;
                if (currentMembers) {
                    let copyText = currentMembers.join("\n");

                    try {
                        await navigator.clipboard.writeText(copyText);
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
            }
        });
    }

    updateTeamsRemovedAccessDisplay(teamsChannelAccessList: TeamsAccessResponseAll[]) {
        let content = "";
        for (let i = 0; i < teamsChannelAccessList.length; i++) {
            let currentTeam = teamsChannelAccessList[i];

            let isMissingMembers: boolean = false;
            if (currentTeam.MissingMembers.length > 0) {
                isMissingMembers = true;
            }

            let accessIcon = `<i class="fa-solid fa-circle-check fa-lg success-icon"></i>`;
            if (isMissingMembers) {
                accessIcon = `<i class="fa-solid fa-circle-xmark fa-lg error-icon"></i>`;
            }

            let title = `
                <div class='d-flex justify-content-between'>
                    <div>
                        <span class="pr-1">${accessIcon}</span>
                        <span class="teams-access-collapse-title">${currentTeam.TeamDisplayName}</span>
                    </div>
                    <div class="collapse-indicator">
                        
                    </div>
                </div>     
            `

            let missingMemberTableInner = ``
            currentTeam.MissingMembers.forEach(email => {
                missingMemberTableInner += `<div class="teams-access-table-row">${email}</div>`
            });

            let copyMissingBtn = `
                <div>
                    <a class="revampp-white-btn copy-remove-access-btn" role="button" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="Copied!" data-placement="top" data-item-index="${i}">Copy <i class="fas fa-copy pl-2"></i></a>
                </div>
            `;

            if (currentTeam.MissingMembers.length == 0) {
                missingMemberTableInner += `<div class="teams-access-table-row text-center">There are no users who should be removed.</div>`
                copyMissingBtn = "";
            }
            let missingMemberTable = `
                <div class="teams-access-table">
                    <div class="teams-access-table-row teams-access-table-head">Email</div>
                    <div class="teams-access-table-body">
                        ${missingMemberTableInner}
                    </div>
                </div>
            `

            let goToTeamBtn = `
                <div class="mb-3">
                    <a href="${currentTeam.TeamsLink}" target="_blank" class="text-decoration-none revampp-white-btn">Go to Team</a>
                </div>
            `      

            let expandContent = `
                <div id="removed-teams-access-list-collapse-${i}" class="teams-access-collapse-content collapse" data-parent="#removed-teams-access-card-parent">               
                    <div class="row p-3">
                        <div class="col-12">
                            <div class="mb-1 d-flex justify-content-between align-items-baseline">
                                <div>
                                    <span class="pr-1"><i class="fa-solid fa-circle-xmark fa-lg error-icon"></i></span>
                                    <span class="teams-access-table-title">Remove from Team or Channel</span>
                                </div>
                                ${copyMissingBtn}
                            </div>
                            ${missingMemberTable}
                        </div>
                    </div>
                </div>
            `

            let teamCard = `
                <div class="teams-access-list-item">
                    <div class="teams-access-item-block collapsed" data-toggle="collapse" data-target="#removed-teams-access-list-collapse-${i}">
                        <div class="teams-access-block-title">
                            ${title}
                        </div>
                    </div>
                    ${expandContent}
                </div>
            `
            content += teamCard;
        }

        let newDisplay = `
            <p class="mb-3">The tables below show if ReVAMPP users have been properly removed from the collaborative team and/or their group's private channels. Users in the "Remove from Team or Channel" table should be removed from the Team or channel due to portal account deactivation or removal from group.</p>
            <div id="removed-teams-access-card-parent">
                ${content}
            </div>
        `

        this.teamsListContainer.empty().html(newDisplay);

        $(".copy-remove-access-btn").on("click", async (e: Event) => {
            let index = $(e.currentTarget).data("item-index");
            if (index != undefined) {
                let i = parseInt(index);
                let missingMembers = this.currentRemovedMemberList[i]?.MissingMembers;
                if (missingMembers) {
                    let copyText = missingMembers.join("\n");

                    try {
                        await navigator.clipboard.writeText(copyText);
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
            }
        });
    }

    async getTeamsChannelAccess(shouldRefresh: boolean = false): Promise<any> {
        let activeUsersInGroup = this.currentUsers.filter(user => user.AppUser.IsActive && user.AppUserGroupList.length > 0);

        let shouldRefreshCheck = "false";
        if (shouldRefresh) {
            shouldRefreshCheck = "true";
        }
        let result: any
        try {
            result = await $.ajax({
                url: `/secure/list-management/list-management?handler=GetMembershipAll`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(activeUsersInGroup), shouldRefresh: shouldRefreshCheck },
            })
            let teamsAccessList: TeamsAccessResponseAll[] = <TeamsAccessResponseAll[]>result;
            return teamsAccessList;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async getTeamsAcceptedInvite(shouldRefresh: boolean = false): Promise<any> {
        let activeUsersInGroup = this.currentUsers.filter(user => user.AppUser.IsActive && user.AppUserGroupList.length > 0);

        let shouldRefreshCheck = "false";
        if (shouldRefresh) {
            shouldRefreshCheck = "true";
        }
        let result: any
        try {
            result = await $.ajax({
                url: `/secure/list-management/list-management?handler=GetAcceptedMembership`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(activeUsersInGroup), shouldRefresh: shouldRefreshCheck },
            })
            let teamsAccessList: TeamsAccessResponseAll[] = <TeamsAccessResponseAll[]>result;
            return teamsAccessList;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async getTeamsRemovedAccess(shouldRefresh: boolean = false): Promise<any> {
        let shouldRefreshCheck = "false";
        if (shouldRefresh) {
            shouldRefreshCheck = "true";
        }
        let result: any
        try {
            result = await $.ajax({
                url: `/secure/list-management/list-management?handler=GetRemovedTeamsAccess`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(this.currentUsers), shouldRefresh: shouldRefreshCheck },
            })
            let teamsAccessList: TeamsAccessResponseAll[] = <TeamsAccessResponseAll[]>result;
            return teamsAccessList;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }
}
